import { render, staticRenderFns } from "./kanwil.vue?vue&type=template&id=7d8c1fb8&"
import script from "./kanwil.vue?vue&type=script&lang=js&"
export * from "./kanwil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports